import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class CodeAirLine extends TrackableEntity {
    id: number = 0;
    prefix: string = '';
    abbr2: string = '';
    abbr3: string = '';
    name: string = '';
    country: string = '';
    billTo: string = '';
    companyID: number = 0;
    accountNo: string = '';
    nextBLno: string = '';
    endBLno: string = '';

    aefscRate: number = 0;
    aesscRate: number = 0;
    aefscMin: number = 0;
    aesscMin: number = 0;
    tsaRate: number = 0;
    tsaMin: number = 0;
    fscgWt: boolean = false;
    sscgWt: boolean = false;
    tsagWt: boolean = false;

    u2Id: string | null = null;
    u2Date: string | null = null;
    

    // for cloud
    indicator?: number;
    // Current operation
    edit: boolean = false;
    view: boolean = false;
    editIndex?: number;
  
    //freightVendor: number = 0; --> companyID
    //freightVendorName: string = ''; --> billTo
    countryUnCode: string = '';
    

    constructor(init?:Partial<CodeAirLine>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return CodeAirLine.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_CODEAIRLINE' }),
        'prefix': new DBMappingInfo({ field: 'F_Prefix', table: 'T_CODEAIRLINE' }),
        'abbr2': new DBMappingInfo({ field: 'F_Abbr', table: 'T_CODEAIRLINE' }),
        'abbr3': new DBMappingInfo({ field: 'F_ABBR3', table: 'T_CODEAIRLINE' }),
        'companyID': new DBMappingInfo({ field: 'F_CompanyID', table: 'T_CODEAIRLINE' }),
        'accountNo': new DBMappingInfo({ field: 'F_AccountNo', table: 'T_CODEAIRLINE' }),
        'nextBLno': new DBMappingInfo({ field: 'F_NextBLno', table: 'T_CODEAIRLINE' }),
        'endBLno': new DBMappingInfo({ field: 'F_EndBLno', table: 'T_CODEAIRLINE' }),
        'aefscRate': new DBMappingInfo({ field: 'F_AEFSCRate', table: 'T_CODEAIRLINE' }),
        'aefscMin': new DBMappingInfo({ field: 'F_AEFSCMin', table: 'T_CODEAIRLINE' }),
        'aesscRate': new DBMappingInfo({ field: 'F_AESSCRate', table: 'T_CODEAIRLINE' }),
        'aesscMin': new DBMappingInfo({ field: 'F_AESSCMIN', table: 'T_CODEAIRLINE' }),
        'country': new DBMappingInfo({ field: 'F_Country', table: 'T_CODEAIRLINE' }),
        'name': new DBMappingInfo({ field: 'F_Name', table: 'T_CODEAIRLINE' }),
        'tsaRate': new DBMappingInfo({ field: 'F_F1', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'tsaMin': new DBMappingInfo({ field: 'F_F2', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'fscgWt': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'sscgWt': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'tsagWt': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_AOTHERINFO', tbName: 'T_CODEAIR', tbId: '@AirCodeId', type: 0 }),

    };
}
